import { GroupDetail } from '../groups/GroupDetail';
import { GroupList } from '../groups/GroupList';
import { AsideLayout } from '../layout/AsideLayout';
import GroupsProvider from '../providers/GroupsProvider';

export function GroupPage() {
  return (
    <>
      <GroupsProvider />
      <AsideLayout aside={<GroupList />}>
        <GroupDetail />
      </AsideLayout>
    </>
  );
}
